import React, { useState } from 'react';
import logo from '../assets/logo.png'; // Path to your logo image in the assets folder

const Header = () => {


  return (
    <div
      className={`flex items-center justify-center pt-5 px-4 py-2 bg-[#191919] text-white shadow-md `}
    >
      
      <div className="flex items-center">
        <img src={logo} alt="Logo" className="w-8 rounded-full grayscale h-8 mr-2" /> {/* Adjust the size of your logo */}
        <div className="text-xl font-semibold">MONERO</div>
      </div>
    
    </div>
  );
};

export default Header;
